import { render, staticRenderFns } from "./MessageSettings.vue?vue&type=template&id=16b68484&scoped=true"
import script from "./MessageSettings.vue?vue&type=script&lang=ts"
export * from "./MessageSettings.vue?vue&type=script&lang=ts"
import style0 from "./MessageSettings.vue?vue&type=style&index=0&id=16b68484&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b68484",
  null
  
)

export default component.exports